import {
  GET_PERSONALIZED_TOURS_DATA,
  GET_PERSONALIZED_TOURS_DATA_SUCCESS,
  GET_PERSONALIZED_TOURS_DATA_FAIL,
  GET_PERSONALIZED_TOURS_DATA_DETAILS,
  GET_PERSONALIZED_TOURS_DATA_DETAILS_SUCCESS,
  GET_PERSONALIZED_TOURS_DATA_DETAILS_FAIL,
  PERSONALIZED_CSV_START,
  PERSONALIZED_CSV_ERROR,
  PERSONALIZED_CSV_SUCCESS,
  GET_PERSONALIZED_TOURS_UPDATE,
  GET_PERSONALIZED_TOURS_UPDATE_SUCCESS,
  GET_PERSONALIZED_TOURS_UPDATE_FAILURE,
} from "../Constants/PersonalizedToursConstant";

const initialState = {
  personalizedToursLoading: false,
  personalizedToursData: [],
  personalizedToursDetailsLoading: false,
  personalizedToursDetails: null,
  personalizedTourCsvLoading: false,
  personalizedTourUpdateLoading: false,
  personalizedTourUpdate: [],
};

export default function PersonalizedToursReducer(
  state = { ...initialState },
  action
) {
  switch (action.type) {
    case GET_PERSONALIZED_TOURS_DATA:
      return {
        ...state,
        personalizedToursLoading: true,
      };
    case GET_PERSONALIZED_TOURS_DATA_SUCCESS:
      return {
        ...state,
        personalizedToursLoading: false,
        personalizedToursData: action.payload,
      };
    case GET_PERSONALIZED_TOURS_DATA_FAIL:
      return {
        ...state,
        personalizedToursLoading: false,
        personalizedToursData: [],
      };
    case GET_PERSONALIZED_TOURS_DATA_DETAILS:
      return {
        ...state,
        personalizedToursDetailsLoading: true,
        personalizedToursDetails: null,
      };
    case GET_PERSONALIZED_TOURS_DATA_DETAILS_SUCCESS:
      return {
        ...state,
        personalizedToursDetailsLoading: false,
        personalizedToursDetails: action.payload,
      };
    case GET_PERSONALIZED_TOURS_DATA_DETAILS_FAIL:
      return {
        ...state,
        personalizedToursDetailsLoading: false,
        personalizedToursDetails: null,
      };
    case PERSONALIZED_CSV_START:
      return {
        ...state,
        personalizedTourCsvLoading: true,
      };
    case PERSONALIZED_CSV_SUCCESS:
      return {
        ...state,
        personalizedTourCsvLoading: false,
      };
    case PERSONALIZED_CSV_ERROR:
      return {
        ...state,
        personalizedTourCsvLoading: false,
      };
    case GET_PERSONALIZED_TOURS_UPDATE:
      return {
        ...state,
        personalizedTourUpdateLoading: true,
      };
    case GET_PERSONALIZED_TOURS_UPDATE_SUCCESS:
      return {
        ...state,
        personalizedTourUpdateLoading: false,
        personalizedTourUpdate: action.payload,
      };
    case GET_PERSONALIZED_TOURS_UPDATE_FAILURE:
      return {
        ...state,
        personalizedTourUpdateLoading: false,
        personalizedTourUpdate: [],
      };
    default:
      return state;
  }
}
